import React from 'react';
import PropTypes from 'prop-types';
import styles from '../styles/BrandMark.module.css';

const LOGO_SRC = `${process.env.PUBLIC_URL}/brand/lotw-mark.png`;

const BrandMark = ({
  size = 48,
  showText = false,
  text = 'LOTW League',
  className = '',
  imageClassName = '',
}) => (
  <div className={`${styles.brandMark} ${className}`}>
    <img
      src={LOGO_SRC}
      alt=""
      aria-hidden="true"
      className={`${styles.logo} ${imageClassName}`}
      style={{ width: size, height: size }}
    />
    {showText && <span className={styles.text}>{text}</span>}
  </div>
);

BrandMark.propTypes = {
  size: PropTypes.number,
  showText: PropTypes.bool,
  text: PropTypes.string,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
};

export default BrandMark;
